<!-- InputTextarea: A textarea field input -->
<template>
        <div class="flex flex-col">        
        <div v-if="textControls" class="mb-2 flex gap-2">
            <Button icon="link" @click="format('link')" title="Link" label="Link" />
            <Button icon="exclamation" @click="format('alert')" title="Alert" label="Alert" />
            <Button icon="info" @click="format('highlight')" title="Highlight" label="Highlight" />
            <Button icon="photo" @click="insertImage" title="Image" label="Image" />
            <Button @click="format('bold')" title="Bold" label="Bold" />
            <Button @click="format('italic')" title="Italic" label="Italic" />
            <Button icon="chevron-up" @click="format('large')" title="Large Text" label="A" />
            <Button icon="chevron-down" @click="format('small')" title="Small Text" label="A" />
        </div>
        <textarea :id="id"   
            ref="refInput"
            :tabindex="index"   
            v-model="input"             
            :class="`border w-full h-full text-left p-1 rounded-sm mn3-input self-stretch`">
        </textarea>
    </div>
</template>
<script>

import { ref, computed } from "vue";

import Button from '@/components/Button.vue'
export default{
    components: {
        Button
    },
    props:{
        /* Properties without defaults */
        id: String,                     //id: ID assigned to the input
        index: Number,                  //index: TabIndex assigned to the input
        textControls: Boolean,
        
        /* Properties with defaults */
        formValue: {                    //formValue: Used to store field input    
            type: Object,
            default: ref("")
        },
    },
    computed: {   
    },
    methods:{     
        format(type) {
            let textarea = this.$refs.refInput;
            if (!textarea) return;
            let [start, end] = [textarea.selectionStart, textarea.selectionEnd];
            let value = this.formValue.value;
            let before = value.substring(0, start);
            let selected = value.substring(start, end);
            let after = value.substring(end);

            let tagOpen = '', tagClose = '';
            if (type === 'bold') {
                tagOpen = '[b]'; tagClose = '[/b]';
            } else if (type === 'italic') {
                tagOpen = '[i]'; tagClose = '[/i]';
            } 
            else if (type === 'header') {
                tagOpen = '[header]'; tagClose = '[/header]';
            } else if (type === 'link') {
                let link = prompt('Enter a link url (including https://)', '');
                if (!link) return;
                tagOpen = `[link=${link}]`; tagClose = '[/link]';
            }
            else if (type === 'color') {
                let color = prompt('Enter a color (e.g. red or #ff0000):', 'red');
                if (!color) return;
                tagOpen = `[color=${color}]`; tagClose = '[/color]';
            } else if (type === 'size') {
                let size = prompt('Enter font size (e.g. 16px or 1.2em):', '16px');
                if (!size) return;
                tagOpen = `[size=${size}]`; tagClose = '[/size]';
            }else{
                tagOpen = '['+type+']'; 
                tagClose = '[/'+type+']';
            }
            this.formValue.value = before + tagOpen + selected + tagClose + after;
        },
        insertImage() {
            let url = prompt('Enter image URL:');
            if (!url) return;
            let textarea = this.$refs.refInput;
            if (!textarea) return;
            let [start, end] = [textarea.selectionStart, textarea.selectionEnd];
            let value = this.formValue.value;
            let before = value.substring(0, start);
            let after = value.substring(end);
            let imgTag = `[img]${url}[/img]`;
            this.formValue.value = before + imgTag + after;
        },
        focus(){
            this.refInput.focus();
        },   
    },
    setup(props, { emit }){
        
        const refInput = ref(null);
        /* --Variables-- */        
        const val = ref(props.formValue);   //val: Used in computed input property

        /* --Computed-- */        
        const input                         //input: holds input value, emits updated event on change
            = computed({
            get: () => val.value,
            set: (v) => (val.value = v,emit('updated', formValue => Object.keys(formValue)[0], v))
        })

        /* --Functions-- */        
        
        return {
            input,
            refInput
        }
    }
}

</script>